import allJs from './js/index';

import './tailwind.css';
import './sass/style.scss';

if (!$("body").hasClass("sfPageEditor")) {
    allJs();
}


// WEBPACK FOOTER //
// ./src/site.js